import store from '@/store'
import { QueryIndustrySimplifyList } from '@/apis/industry'
const enumsData = store.state.enumsStore.enumsData
const { DeviceType } = enumsData
const industryList = []
async function getIndustryList(){
  try {
    const { collection: data } = await QueryIndustrySimplifyList({page:1, prePage:100})
    data.forEach(val => {
      industryList.push({ id: val.id, name: val.name })
    })
    console.log(industryList)
  } catch (error) {}
}
getIndustryList()
export const searchItems = [
  // 展示名称
  {
    label: '所属行业',
    type: 'select',
    decorator: ['industryId'],
    placeholder: '请选择',
    option: {data: industryList}
  },
  // 展示名称
  {
    label: '设备类型',
    type: 'select',
    decorator: ['deviceTypes'],
    mode: 'multiple',
    placeholder: '请选择',
    option: {data: DeviceType, key: 'code'}
  },
  {
    label: '关键字',
    type: 'input',
    decorator: ['keyword'],
    placeholder: '请输入门店名称ID'
  },
]
